const postEquipmentServices = {
  toastr: 'Added service',
  massService: 'Added mass service',
  toastrError: 'Service Type already registered',
  toastrError1: 'Enter another name'
};

export default postEquipmentServices;
